<div class="page-container">
  <app-header></app-header>
  <app-menu></app-menu><br>
  <div class="p-2 mysettinglistinh">
    <div class="p-3" style="border: 1px solid #004aad; border-radius: 5px;">
    <mat-stepper [linear]="isLinear" (selectionChange)="onStepChange($event) "
      #stepper>
      <!-- STEP 1 -->
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel>Property Details</ng-template>
          <div fxLayout="row wrap" fxLayoutGap="16px">

            <div class="row col-md-12">
              <div class="custom-form-field4">
                <mat-form-field>
                  <mat-label>Property Title</mat-label>
                  <input matInput placeholder formControlName="title" required>
                  <mat-error
                    *ngIf="firstFormGroup.controls['title'].hasError('required')">Property
                    Title is required</mat-error>
                </mat-form-field>
              </div>
            </div><br>

            <div class="row col-md-12">
              <div class="custom-form-field4">
                <label
                  for="middleName"
                  class="post-headings"
                  [ngStyle]="{
                      color:
                        description.invalid && (description.dirty || description.touched)
                          ? '#f44336'
                          : isFocused
                          ? '#004aad'
                          : 'rgb(136, 110, 110)'
                    }">
                  Description *
                </label>
                <textarea
                  formControlName="description"
                  class="description-textarea"
                  (focus)="isFocused = true"
                  (blur)="isFocused = false"
                  [ngClass]="{ 'border-error': description.invalid && (description.dirty || description.touched) }"></textarea>
                <div
                  *ngIf="description.invalid && (description.dirty || description.touched)"
                  class="text-dangers">
                  Description is required.
                </div>
              </div>
            </div>

            <!-- 2. Property Type -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Property Type</mat-label>
              <mat-select formControlName="type" required
                (selectionChange)="onTypeChange($event.value)">
                <mat-option value="Residential">Residential</mat-option>
                <mat-option value="Commercial">Commercial</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- 3. Condition -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Condition</mat-label>
              <mat-select formControlName="furnishing">
                <mat-option value="Furnished">Furnished</mat-option>
                <mat-option value="semifurnished">Semi Furnished</mat-option>
                <mat-option value="Unfurnished">Unfurnished</mat-option>
              </mat-select>
              <mat-error *ngIf="firstFormGroup.controls['furnishing'].hasError('required')">Condition Type is required</mat-error>

            </mat-form-field>

            <!-- 4. What do you have -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>What do you have</mat-label>
              <mat-select formControlName="propertyType" required>
                <mat-option *ngFor="let option of filteredpropertyTypes"
                  [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="firstFormGroup.controls['propertyType'].hasError('required')">What do you have is required</mat-error>

            </mat-form-field>
            <!-- 5. Amenities -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status">
                <mat-option value="fresh">Fresh</mat-option>
                <mat-option value="sold">Sold</mat-option>
                <mat-option value="active">Active</mat-option>
                <mat-option value="inactive">Inactive</mat-option>
                <mat-option value="draft">Draft</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- 14. Address -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Address</mat-label>
              <input matInput formControlName="address" required />
                    <mat-error
                    *ngIf="firstFormGroup.controls['address'].hasError('required')">Property
                    Address is required</mat-error>
            </mat-form-field>

            <!-- 15. Locality -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Locality</mat-label>
              <input matInput formControlName="area" required />
       <mat-error
                    *ngIf="firstFormGroup.controls['area'].hasError('required')">Property
                    Locality is required</mat-error>
            </mat-form-field>


                <mat-form-field class="custom-form-field" fxFlex="calc(33.33% - 16px)">
              <mat-label>City</mat-label>
              <input
                type="text"
                placeholder="Search City"
                (keyup)="onCitySearch($event)"
                aria-label="text"
                matInput
                formControlName="cityName"
                [matAutocomplete]="auto"
                required

                >
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCityChange($event)" [displayWith]="displayCityName">
                  <mat-option *ngFor="let city of cityDataList" [value]="city">
                    {{ city.name }}
                  </mat-option>
                </mat-autocomplete>



              <mat-error *ngIf="firstFormGroup.controls['cityName'].hasError('required')">
                City is required
              </mat-error>
            </mat-form-field>
            <mat-form-field class="custom-form-field" fxFlex="calc(33.33% - 16px)">
              <mat-label>State</mat-label>
              <mat-select formControlName="stateId" required>
                <mat-option *ngIf="stateId" [value]="stateId">
                  {{ stateName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="firstFormGroup.controls['stateId'].hasError('required')">State is required</mat-error>

            </mat-form-field>
          </div>

          <div class="button-container">
            <button mat-button class="custom-button font1 onlyhover "
              type="button" (click)="handleCancel()">Cancel</button>
            <button mat-button class="custom-button font1 onlyhover"
             (click)="stepper.next()">Next</button>
          </div>
        </form>
      </mat-step>

      <!-- STEP 2 -->
      <mat-step [stepControl]="secondFormGroup" label="Property Features">
        <form [formGroup]="secondFormGroup">
          <div fxLayout="row wrap" fxLayoutGap="16px">
            <!-- 8. Super Built-Up Area -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Super Built-Up Area</mat-label>
              <input matInput formControlName="buildupArea" required />
            </mat-form-field>

            <!-- 9. Cover Area -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Cover Area</mat-label>
              <input matInput formControlName="coverArea" required />
            </mat-form-field>

            <!-- 10. Age Of Construction -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Age Of Construction</mat-label>
              <!-- <input matInput formControlName="construction" required /> -->

              <mat-select formControlName="construction">
                <mat-option>None</mat-option>
                <mat-option value="1">1</mat-option>
                <mat-option value="2">2</mat-option>
                <mat-option value="3">3</mat-option>
                <mat-option value="4">4+</mat-option>

              </mat-select>
            </mat-form-field>

            <!-- 11. Parking -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Parking</mat-label>

              <mat-select formControlName="widthOfFacingRoadUnit">
                <mat-option>None</mat-option>
                <mat-option value="Dedicated">Dedicated</mat-option>
                <mat-option value="Open">Open</mat-option>

              </mat-select>
            </mat-form-field>

            <!-- 12. Floor -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Floor</mat-label>
              <!-- <input matInput formControlName="totalFloors" required /> -->
              <mat-select formControlName="totalFloors">
                <mat-option>None</mat-option>
                <mat-option value="ground">Ground Floor</mat-option>
                <mat-option value="2">1 Floor</mat-option>
                <mat-option value="3">2 Floor</mat-option>
                <mat-option value="4">3 Floor</mat-option>
                <mat-option value="4">4 Floor</mat-option>

              </mat-select>
            </mat-form-field>

            <!-- 13. Water Supply -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Water Supply</mat-label>
              <mat-select formControlName="waterSource">
                <mat-option>None</mat-option>
                <mat-option value="24hour">24 Hour</mat-option>
                <mat-option value="2to12hour">2 to 12 Hour</mat-option>

              </mat-select>
            </mat-form-field>

            <!-- 18. Price Details -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Rent Price/Month</mat-label>
              <input matInput formControlName="propertyRentPrice" required />
            </mat-form-field>

            <!-- 19. Maintenance Charge -->
            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Maintenance Charge</mat-label>
              <input matInput formControlName="maintenanceCharge" required />
            </mat-form-field>



            <mat-form-field class="custom-form-field"
              fxFlex="calc(33.33% - 16px)">
              <mat-label>Amenities</mat-label>
           <mat-select placeholder="Select Amenities"
            formControlName="amenities" multiple required>

                <mat-option value="Security">Security</mat-option>
                <mat-option value="Garden">Garden</mat-option>
                <mat-option value="Gym">Gym</mat-option>
                <mat-option value="Guest Suite">Guest Suite</mat-option>
                <mat-option value="Banquet Hall">Banquet Hall</mat-option>
                <mat-option value="Meeting Room">Meeting Room</mat-option>
                <mat-option value="Music Room">Music Room</mat-option>
                <mat-option value="Swimming Pool">Swimming Pool</mat-option>
                <mat-option value="Pool">Pool</mat-option>
                <mat-option value="Game Room">Game Room</mat-option>
                <mat-option value="Study Room">Study Room</mat-option>
              </mat-select>

              <mat-error
                *ngIf="secondFormGroup.controls['amenities'].hasError('required')">Amenity
                is required</mat-error>
            </mat-form-field>










          </div>

          <div class="button-container">
            <button mat-button class="custom-button font1 onlyhover setbutton"
              type="button" (click)="stepper.previous()">Back</button>
            <button mat-button class="custom-button font1 onlyhover setbutton"
              type="button" (click)="stepper.next()">Next</button>
          </div>
        </form>
      </mat-step>

      <!-- STEP 3 -->
      <mat-step [stepControl]="thirdFormGroup" label="Media Upload">
        <form [formGroup]="thirdFormGroup">
          <div fxLayout="row wrap" fxLayoutGap="16px">

            <mat-form-field class="custom-form-field1">
              <div>
                <mat-toolbar>
                  <input matInput
                    [value]="selectedFileNames.length ? selectedFileNames.join(', ') : 'Select Images*'"
                    readonly />
                  <button mat-flat-button color="primary" class="setbutton"
                    [disabled]="!selectedFiles.length"
                    (click)="uploadFiles()">Upload</button>
                </mat-toolbar>
                <input type="file" id="fileInput" formControlName="imageUrls"
                  (change)="handleChange($event)"
                  name="fileInput" accept="image/*" multiple hidden />
                <button mat-stroked-button color="primary"
                  (click)="triggerFileInput()">Select Image</button>
              </div>

            </mat-form-field>
            <div class="uploaded-images">
              <div *ngFor="let image of uploadedImages; let i = index"
                class="uploaded-image-container">
                <img [src]="image" alt="Uploaded Image"
                  class="uploaded-image" />
                <button mat-icon-button style="color:#004aad ;"
                  (click)="removeImage(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <!-- Video Upload Section -->
            <mat-form-field class="custom-form-field1" fxFlex="100%">
              <div>
                <mat-toolbar>
                  <input matInput
                    [value]="selectedVideoFileNames.length ? selectedVideoFileNames.join(', ') : 'Select Videos*'"
                    readonly />
                  <button mat-flat-button color="primary"
                    [disabled]="!selectedVideoFiles.length"
                    (click)="uploadVideoFiles()">Upload</button>
                </mat-toolbar>
                <input type="file"
                  id="videoInput"
                  formControlName="videoUrls"
                  (change)="handleVideoChange($event)"
                  name="videoInput"
                  accept="video/*"
                  multiple
                  hidden />
                <button mat-stroked-button color="primary"
                  (click)="triggerVideoInput()">Select Video</button>
              </div>
            </mat-form-field>
            <div class="uploaded-videos">
              <div *ngFor="let video of uploadedVideos; let i = index"
                class="uploaded-video-container">
                <video width="250" controls>
                  <source [src]="video" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <button mat-icon-button style="color:#004aad;"
                  (click)="removeVideo(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="button-container">
            <button mat-button class="custom-button font1 onlyhover"
              type="button" (click)="stepper.previous()">Back</button>
            <button mat-button class="custom-button font1 onlyhover"
              type="submit" (click)="onSubmit()">Submit</button>
          </div>
        </form>
      </mat-step>
    </mat-stepper>

  </div>
  </div>
</div>
